import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

import shareIcon from "../../../assets/images/share.png";
import closeIcon from "../../../assets/images/close.png";
import arrowIconWhite from "../../../assets/images/arrowIconWhite.png";

import Img from "../../../assets/images/sezione-05-popup-03-01-img-01.svg";

import Ico1 from "../../../assets/images/ico_popup_finalità/sezione-05-popup-03-01-ico-01.svg";
import Ico2 from "../../../assets/images/ico_popup_finalità/sezione-05-popup-03-01-ico-02.svg";
import Ico3 from "../../../assets/images/ico_popup_finalità/sezione-05-popup-03-01-ico-03.svg";
import Ico4 from "../../../assets/images/ico_popup_finalità/sezione-05-popup-03-01-ico-04.svg";
import Ico5 from "../../../assets/images/ico_popup_finalità/sezione-05-popup-03-01-ico-05.svg";
import Ico6 from "../../../assets/images/ico_popup_finalità/sezione-05-popup-03-01-ico-06.svg";

const ITEMS = [
  {
    verb: "Offer",
    icon: Ico1,
    text:
      'Offer products/services aimed at continuously improving the relationship with Members/Policyholders-Customers, generating economic, social and environmental value while enhancing the mutualistic nature of the Company.',
  },
  {
    verb: "Develop",
    icon: Ico2,
    text:
      "Develop projects and initiatives aimed at promoting health, well-being and inclusion.",
  },
  {
    verb: "Support",
    icon: Ico3,
    text:
      "Support the personal and professional growth of employees, collaborators and directors, also through training and cultural activities and the development of corporate welfare initiatives.",
  },
  {
    verb: "Mitigate",
    icon: Ico4,
    text:
      "Mitigate the environmental impacts of its activities, in order to contribute to the protection of the environment and ecosystem.",
  },
  {
    verb: "Operate",
    icon: Ico5,
    text:
      "Operate responsibly and transparently towards business partners and suppliers, adopting preferential selection criteria for entities that responsibly manage environmental and social impacts.",
  },
  {
    verb: "Contribute",
    icon: Ico6,
    text:
      "Contribute to the implementation of projects of collective interest, also in collaboration with public institutions, local authorities, private for-profit and non-profit enterprises, in order to create shared value for the territory and community.",
  },
];

export default function BeneficioComune({ isOpen, onClose }) {
  const overlayRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
      window.addEventListener("keydown", onKey);
    }
    return () => {
      document.body.classList.remove("overflow-hidden");
      window.removeEventListener("keydown", onKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const onShare = (popupId) => {
    const url = new URL(window.location.href);
    url.searchParams.set("popup", popupId);

    if (navigator.share) {
      navigator
        .share({ title: "6 Common Benefit Objectives", url: url.toString() })
        .catch(() => {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url.toString()).catch(() => {});
    }
  };

  return createPortal(
    <div
      ref={overlayRef}
      className="fixed inset-0 z-[2400] bg-black/50 backdrop-blur-[2px] flex items-center justify-center p-3 md:p-6"
      onMouseDown={(e) => { if (e.target === overlayRef.current) onClose?.(); }}
      role="dialog"
      aria-modal="true"
      aria-label="6 Common Benefit Objectives"
    >
      <div
        className="relative w-full md:w-[1280px] bg-white max-h-[90vh] overflow-y-auto overscroll-contain"
        style={{ background: "#E7E3DF", WebkitOverflowScrolling: "touch" }}
        onMouseDown={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="sticky top-3 z-10 flex items-center gap-2 justify-end pr-3">
          <button
            onClick={() => onShare("BeneficioComune")}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            title="Share"
            aria-label="Share"
          >
            <img src={shareIcon} alt="" className="h-4 w-4" />
          </button>
          <button
            onClick={onClose}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            title="Close"
            aria-label="Close"
          >
            <img src={closeIcon} alt="Close" className="h-4 w-4" />
          </button>
        </div>

        {/* Contenuto */}
        <div className="p-8">
          <h2 className="text-[#0E3761] text-[30px] md:text-[40px] font-normal">
            6 Common Benefit Objectives
          </h2>

          <p className="text-[#0E3761] text-[16px] md:text-[24px] mt-2 leading-[1.1em]">
            In 2022, <b>the parent company Reale Mutua</b> obtained <b>Benefit Corporation</b> status and <b>amended its Articles of Association</b> by introducing six Common Benefit Objectives, 
            <b> committing to generate positive and measurable impacts</b> not only for its Members/Policyholders-Clients, but also for all stakeholders directly or indirectly involved.
          </p>

          {/* Blocco centrale */}
          <div className="mt-12 border border-[#0E3761]/10 rounded md:rounded-none overflow-hidden">
            <div className="flex flex-col md:flex-row">
              {/* Immagine (sopra su mobile) */}
              <div className="md:w-[38%] bg-[#E7B835] p-6 md:p-8 flex items-end justify-center">
                <img src={Img} alt="" className="w-full max-w-[360px] h-auto" />
              </div>

              {/* Sezioni (icone + testi) */}
              <div className="md:w-[62%] bg-[#F5EBDD] p-6 md:p-8">
                {ITEMS.map((it, i) => (
                  <div
                    key={i}
                    className={`flex items-start gap-4 py-3 ${i !== 0 ? "border-t border-[#0E3761]/10" : ""}`}
                  >
                    <div className="w-[110px] md:w-[140px] shrink-0 ">
                      <div className="text-[#0E3761] font-bold mb-2 text-[20px]">{it.verb}</div>
                      <img src={it.icon} alt="" className="w-[60%]" />
                    </div>
                    <div className="flex-1 text-[#0E3761] text-[16px] md:text-[20px] leading-[1.25] font-bold">
                      <span className="text-[#E7B835] font-bold mr-2">{i + 1}.</span>
                      {it.text}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* CTA finale */}
          <div className="mt-6">
            <a href="https://www.realegroup.eu/groupshare/0/EN/ListaReportsAndAccounts/65/Relazione%20di%20Impatto%202025%20ENG.pdf" target="_blank">
              <button
                className="bt-secondary2 text-sm px-4 py-2"
                type="button"
              >
                <img
                  src={arrowIconWhite}
                  alt="Arrow"
                  className="inline-block mr-2 w-[20px] h-[20px]"
                />
                Consult the Impact Report
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}